/* global additionalAccessoriesArray, additionalAccessoriesPromise, ApplePaySession, braintree, ga */
'use strict';
import {
	htmlspecialchars
} from "~/common/utilities/utilities";

import {
	configApplePay,
	configGooglePay,
	configPaypal
} from "~/public/utilities/utilities";

import responsiveAccessoryPopupSingle from "./accessoryRecommendationSingle";

/**
 * Cart methods.
 * @namespace
 */
var responsiveCart = {
	/**
	 * The jQuery element representing the accessory modal.
	 * @type jQuery|$|_$|Element
	 */
	accessoryModal: null,
	/**
	 * The jQuery element representing the accessory status elemnts in each item row.
	 * @type jQuery|$|_$|Element
	 */
	accessoryStatus: null,
	/**
	 * The jQuery element representing the cart form.
	 * @type jQuery|$|_$|Element
	 */
	cartForm: null,
	/**
	 * The delete checkboxes (if available).
	 * @type jQuery|$|_$|Element
	 */
	deleteCheckboxes: null,
	/**
	 * The Delete Selected buttons (if available).
	 * @type jQuery|$|_$|Element
	 */
	deleteSelectedButton: null,
	/**
	 * The jQuery element representing the modal that is displayed when the form is submitted.
	 * @type jQuery|$|_$|Element
	 */
	interstitialModal: null,
	/**
	 * The jQuery element representing the bounding element after the cart itme list on phones.
	 * @type jQuery|$|_$|Element
	 */
	itemRowEnd: null,
	/**
	 * Provides check for onlyDesktop and onlyMobile logic.
	 * @type {Object}
	 */
	screenSize: {
		/**
		 * Bootstrap extra small devices only (less than 576px).
		 * @returns {Boolean}
		 */
		extraSmallOnly: function() {
			return window.innerWidth < 576;
		},
		/**
		 * Bootstrap small and extra small devices (less than 768px).
		 * @returns {Boolean}
		 */
		smallAndSmaller: function() {
			return window.innerWidth < 768;
		}
	},
	/**
	 * The jQuery element representing the modal used to submit the customer's zip code.
	 * @type jQuery|$|_$|Element
	 */
	zipModal: null,
	/**
	 * Initializes all event listeners for the cart. Init is executed on document ready.
	 * @returns {undefined}
	 */
	init: function() {
		this.accessoryModal = $('#Waccessory');
		this.accessoryStatus = $('.accessory-status');
		this.cartForm = $('#cart_form');
		this.deleteCheckboxes = $('.delete_checkbox');
		this.deleteSelectedButton = $('.remove-selected-btn');
		this.interstitialModal = $('#savingModal');
		this.itemRowEnd = $('#item-row-end');
		this.zipModal = $('#zip-modal');

		// Register the analytics events before registering other event handlers.
		this.eventTracking();

		this.installAccessoryPopupController.init();
		responsiveAccessoryPopupSingle.init();

		this.cartForm.on('submit', this.showInterstitialModal);

		this.cartForm.change(responsiveCart.inputChange);

		if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
			configApplePay();
		} else {
			//  remove the button if not in used to avoid extra white spacing from its container
			$('.expressCheckoutBtnContainer .btn-apple-pay.payment-method').remove();
		}

		if ($('#google-pay-button').length > 0) {
			configGooglePay();
		}

		if ($('#paypal-button-buy-now').length > 0) {
			configPaypal();
		}

		$('.add-accessory').click(responsiveCart.addAccessory);

		$('.bottomCartCheckout').click(responsiveCart.proceedToCheckout);

		$('.email-cart-link').click(responsiveCart.emailCartHandler);

		$('.forgetsaveditem-btn').click(responsiveCart.showInterstitialModal);

		$('.movetocart-btn').click(responsiveCart.showInterstitialModal);

		$('.remove-item').click(responsiveCart.removeItem);

		$('.saveforlater-btn').click(responsiveCart.showInterstitialModal);

		$('.upgradeToBundle').click(responsiveCart.upgradeToBundle);

		if (this.accessoryModal.length > 0) {
			$(document.body).addClass('accessory-modal-open');
		}

		$(document.body).tooltip({
			boundary: '#Waccessory',
			container: '#Waccessory',
			html: true,
			placement: responsiveCart.screenSize.smallAndSmaller() ? 'right' : 'bottom',
			selector: '.accessoryInfoTooltip'
		});

		$('[data-toggle="tooltip"]').not('.accessoryInfoTooltip').tooltip();

		$(".couponTooltip").popover({ trigger: "manual" , html: true, animation:false})
			.on("mouseenter", function () {
				var _this = this;
				$(this).popover("show");
				$(".popover").on("mouseleave", function () {
					$(_this).popover('hide');
				});
			}).on("mouseleave", function () {
			var _this = this;
			setTimeout(function () {
				if (!$(".popover:hover").length) {
					$(_this).popover("hide");
				}
			}, 300);
		});

		$(document.body).on('click', '.couponTerms', function(e) {
			let $link = $(this),
				couponId = $link.closest('.popover-header').find('.couponName').attr('id'),
				termsBody = $('.termsBody');

			termsBody.each( function (){
				if($(this).data('couponId') == couponId)
				{
					e.preventDefault();
					$.fancybox({
						content: $(this).html(),
						autoCenter: true,
						wrapCSS: 'customFancyBox',
						fitToView: true,
					});
				}
			});
		});

		$(window).resize(function() {
			responsiveCart.accessoryStatusPlacement();
			responsiveCart.initMobTopYourCartSection();
		}).resize();

		$('.skipVehicleSelection').on('click', function() {
			responsiveCart.interstitialModal.modal('show');
			responsiveCart.interstitialModal.css('z-index', '11111');
			responsiveCart.accessoryModal.css('z-index', '1997');
		});

		$('.moreDetailsDropdown').on('click', function() {
			let $this = $(this),
				title = $this.find('.detail');

			if ($this.hasClass('collapsed')) {
				title.text('Less details');
			} else {
				title.text('More details');
			}
		});

		// Deletes the current url and redirect to new URL.
		$('.continueToCartBtn').on('click', function() {
			let newUrl = $(this).data('url');

			window.location.replace(newUrl);
		});

		// Show more coupon warnings.
		let couponMessages = $('.couponMessages');

		if (couponMessages.length > 1) {
			couponMessages.first().removeClass('hide');
			couponMessages.closest('.alert').addClass('couponWarningContainer');
			$('.couponWarningContainer').click(function() {
				$(this).toggleClass('active');
			});
		}

		$('.promoApplyBtn').on('click', function() {
			responsiveCart.cartForm.submit();
		});

		responsiveCart.clipCouponController();

	},

	/**
	 * Clip (Adding) the coupon to the cart.
	 * @returns {undefined}
	 */
	clipCouponController: function () {
		let clipCoupon = $('.clipCoupon'),
			couponCode = clipCoupon.data('couponCode');
		clipCoupon.click(function (){
			let $this = $(this);
			if(!$this.hasClass('applied')) {
				$.ajax({
					url: "/cart/clip",
					type: "POST",
					data: {
						coupon: couponCode,
						action: 'add'
					},
					success: function(res) {
						if (res.success) {
							$this.addClass('applied').html("&#10004; Applied!");
						}
						else {
							$this.closest('.couponOuterContainer').find('.couponErrMsg').html(res.error);
						}
					}
				});
			}
		});
	},

	/**
	 * Changes the location of the vehicle accessories panel in each item row.
	 * @returns {undefined}
	 */
	accessoryStatusPlacement: function() {
		this.accessoryStatus.each(function() {
			let accessoryStatus = $(this),
				itemRow = accessoryStatus.closest('.itemRow'),
				itemInfoHeader = itemRow.find('.itemInfoHeader'),
				itemAccessoriesSection = itemRow.find('.itemAccessoriesSection');

			if (responsiveCart.screenSize.smallAndSmaller()) {
				accessoryStatus.insertAfter(itemAccessoriesSection);
			} else {
				accessoryStatus.appendTo(itemInfoHeader);
			}
		});
	},
	/**
	 * Builds and submits the add head unit accessory form.
	 * @param {Event} event
	 * @returns {undefined}
	 */
	addAccessory: function(event) {
		event.preventDefault();
		responsiveCart.showInterstitialModal();
		let destination = '/cart/index',
			$elem = $(this),
			form = document.createElement('form'),
			params = {},
			relatedToId = $elem.data('relatedTo');

		destination = destination + '?afg[year]=' + $elem.data('year');
		destination = destination + '&afg[make]=' + $elem.data('make');
		destination = destination + '&afg[model]=' + $elem.data('model');
		destination = destination + '&afg[body]=' + $elem.data('body');
		destination = destination + '&afg[trim]=' + $elem.data('trim');
		destination = destination + '&afg[audio]=' + $elem.data('audio');

		params[$elem.data('type')] = 'yes';
		params['action'] = 'update_car_specific_accessories';
		params['cart_item_id'] = relatedToId;
		params['from_cart_page'] = 'yes';

		$('.accessory-item-' + relatedToId).each(function() {
			params[$elem.data('selectedType')] = 'yes';
		});

		form.method = 'POST';
		form.action = destination;
		for (let key in params) {
			if (params.hasOwnProperty(key)) {
				let hiddenField = document.createElement('input');

				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		form.submit();
	},
	/**
	 * Opens the email cart form.
	 * @param {Event} event
	 * @returns {undefined}
	 */
	emailCartHandler: function(event) {
		event.preventDefault();
		$.fancybox({
			type: 'iframe',
			href: '/email_cart.php?fancyboxed=1',
			autoCenter: true,
			fitToView: true,
			autoSize: true,
			padding: 0,
			scrolling: 'yes',
			height: 600,
			width: 750,
			wrapCSS: 'bg-grey-wrap'
		});
	},
	/**
	 * Sets up all the event tracking.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		let getItemProductId = function($el) {
			return $el.closest('.itemRow').data('item-product-id');
		};
		$(document.body).on('change', '.itemRow .delete_checkbox', function() {
			let $this = $(this),
				itemId = getItemProductId($this);

			if ($this.is(':checked')) {
				ga('send', 'event', 'Cart', 'Cart items', 'Checkbox selected - ' + itemId);
			} else {
				ga('send', 'event', 'Cart', 'Cart items', 'Checkbox de-selected - ' + itemId);
			}
		});
		$(document.body).on('click', '.itemRow .remove-item:not(.removeAccessory)', function() {
			ga('send', 'event', 'Cart', 'Cart items', 'Remove button - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .saveforlater-btn', function() {
			ga('send', 'event', 'Cart', 'Cart items', 'Save for later - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .movetocart-btn', function() {
			ga('send', 'event', 'Cart', 'Saved for later', 'Move to cart - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .forgetsaveditem-btn', function() {
			ga('send', 'event', 'Cart', 'Saved for later', 'Remove Saved Item - ' + getItemProductId($(this)));
		});
		$(document.body).on('change', '.itemRow .select-qty', function() {
			ga('send', 'event', 'Cart', 'Cart items', 'Quantity selector - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .accessory-status', function() {
			let $this = $(this),
				itemId = getItemProductId($this);

			if ($this.hasClass('collapsed')) {
				ga('send', 'event', 'Cart', 'Cart items', 'Accessories (show) - ' + itemId);
			} else {
				ga('send', 'event', 'Cart', 'Cart items', 'Accessories (hide) - ' + itemId);
			}
		});
		$(document.body).on('click', '.itemRow .itemAccessoriesSection ul .accessoryCtaBtns .add-accessory', function() {
			ga('send', 'event', 'Cart', 'Cart items', 'Accessories (add button) - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .itemAccessoriesSection ul .accessoryCtaBtns .remove-item', function() {
			ga('send', 'event', 'Cart', 'Cart items', 'Accessories (remove button) - ' + getItemProductId($(this)));
		});
		$(document.body).on('click', '.itemRow .warrantyDropDown', function() {
			let $this = $(this),
				itemId = getItemProductId($this);

			if ($this.hasClass('collapsed')) {
				ga('send', 'event', 'Cart', 'Cart items', 'Extended warranty (show) - ' + itemId);
			} else {
				ga('send', 'event', 'Cart', 'Cart items', 'Extended warranty (hide) - ' + itemId);
			}
		});
		$(document.body).on('click', '.itemRow .extended-offer-card', function() {
			let $this = $(this),
				itemId = getItemProductId($this);

			if ($this.hasClass('checked')) {
				ga('send', 'event', 'Cart', 'Cart items', 'Extended warranty (remove) - ' + itemId);
			} else if ($this.parent().find('.extended-offer-card.checked').length > 0) {
				ga('send', 'event', 'Cart', 'Cart items', 'Extended warranty (change) - ' + itemId);
			} else {
				ga('send', 'event', 'Cart', 'Cart items', 'Extended warranty (add) - ' + itemId);
			}
		});
		$(document.body).on('click', '.itemRow .forgetsavedite-btn', function() {
			ga('send', 'event', 'Cart', 'Saved for later', 'Remove - ' + getItemProductId($(this)));
		});

		$('.zip-modal-link').on('click', function() {
			ga('send', 'event', 'Cart', 'Summary', 'Zip code change');
		});

		$('.promoApplyBtn').on('click', function() {
			ga('send', 'event', 'Cart', 'Summary', 'Promo code apply button');
		});
		$('.coupon-input').on('change', function() {
			ga('send', 'event', 'Cart', 'Summary', 'Promo code apply button');
		});
		$('.promoRestrictionLink').on('click', function() {
			ga('send', 'event', 'Cart', 'Summary', 'Promo code restrictions link');
		});

		$('.saveForLaterLogin').on('click', function() {
			ga('send', 'event', 'Cart', 'Saved for later', 'Login button');
		});

		$('#topYourCart .bottomCartCheckout').on('click', function() {
			ga('send', 'event', 'Cart', 'Top', 'Checkout button');
		});

		$('#botCheckoutCont .bottomCartCheckout').on('click', function() {
			ga('send', 'event', 'Cart', 'Summary', 'Checkout button');
		});

		$('.email-cart-link').on('click', function() {
			ga('send', 'event', 'Cart', 'Bottom', 'Email cart');
		});
	},
	/**
	 * This function will set the sticky of your cart section
	 * viewport while scroll down the page.
	 * @returns {undefined}
	 */
	initMobTopYourCartSection: function() {
		var $topYourCart = $('#topYourCart');
		if ($topYourCart.length < 1) {
			return;
		}
		var $topYourCartCont = $topYourCart.parent().css('height', $topYourCart.outerHeight() + 'px');

		var isInViewport = function($elem, buffer) {
			var elementTop = $elem.offset().top;
			var elementBottom = (elementTop + $elem.outerHeight()) - (buffer || 0);

			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();

			return elementBottom > viewportTop && elementTop < viewportBottom;
		}

		var $botCheckoutBtn = $('#cart-bottom-panel .bottomCartCheckout');

		$(window).on('resize scroll', function() {
			if (isInViewport($topYourCartCont, 100) || isInViewport($botCheckoutBtn)) {
				$topYourCart.removeClass('position-fixed');
			} else {
				$topYourCart.addClass('position-fixed');
			}
		});
	},
	/**
	 * Event handler for delegating all form input change events to the cart form.
	 * When the checkboxes change the remove selected button is enabled or disabled
	 * and for all other input and select elements the form is submitted.
	 * @param {Event} event
	 * @returns {undefined}
	 */
	inputChange: function(event) {
		let $elem = $(event.target);

		if ($elem.attr('type') === 'checkbox') {
			responsiveCart.deleteSelectedButton.prop('disabled', responsiveCart.deleteCheckboxes.filter(':checked').length < 1);
		} else if ($elem.attr('name') !== 'payment-method') {
			responsiveCart.cartForm.submit();
		}
	},
	/**
	 * Namespace for the cart install accessory pop-up that loads when a head unit or speaker is added to the cart.
	 * The event handlers for the recommended accessory (add-ons) pop-up that loads when a
	 * head unit or speaker is added to the cart are in responsiveAccessoryPopupSingle module.
	 * @namespace
	 */
	installAccessoryPopupController: {
		/**
		 * Storage used to keep track of the recommended add-ons selected in the
		 * pop-up that appears when a head unit or speaker is added to the cart.
		 * @type {Object}
		 */
		accessoriesAdded: {},
		/**
		 * Sets up all the event handlers for the install accessory pop-up that loads
		 * when a head unit or speaker is added to the cart.
		 * @returns {undefined}
		 */
		init: function() {
			let firstItemLocationCheckBox = $('#speakerLocationList .itemLocation').first();

			if (firstItemLocationCheckBox.length) {
				firstItemLocationCheckBox.prop('checked', true);
				$('#selectedLocationLabel').html('<span style="font-weight: normal;">Selected location:</span> ' + firstItemLocationCheckBox.val() + '. <span style="font-weight: normal;">Total:</span> $' + $('#accessory-cart-item-price').val());
			}

			this.updateCartButton();

			$(document.body).on('change', '#accessoriesData .add-checkbox', function(e) {
				e.preventDefault();
				responsiveCart.installAccessoryPopupController.updateCartButton();
			});

			$(document.body).on('change', '.accessoryCode', this.addInstallAccessoryMultLoc);

			$(document.body).on('click', '#continueToAccessoryBtn', this.continueToInstallAccessories);

			$(document.body).on('click', '#declineAccessoriesBtn', this.declineAccessoriesHandler);

			$(document.body).on('click', '#fitSpeakerList a.fitSpeakerLoc', this.submitAccessoryFormAndGoToSpeakerFitLocation);

			$(document.body).on('click', '#speakerLocationBtn', this.showVehicleSpeakerLocationFromNoFit);

			$(document.body).on('change', '#speakerLocationList .itemLocation', this.speakerLocationListChange);

			$(document.body).on('click', '#viewSpeakerLocation', this.showVehicleSpeakerLocationFromFit);

			$(document.body).on('change', '.warrantyCode', this.addWarrantyMultLoc);

			$(document.body).on('hide.bs.collapse', '.extended-warranty-more-info', function() {
				$(this).parent().find('.extended-warranty-read-more').text('Read more');
			});
			$(document.body).on('show.bs.collapse', '.extended-warranty-more-info', function() {
				$(this).parent().find('.extended-warranty-read-more').text('Read less');
			});

			// Extra add-on accessory cheange handler.
			let accessoriesAdded = {};

			if ('undefined' !== typeof additionalAccessoriesArray && 'undefined' !== typeof additionalAccessoriesPromise) {
				additionalAccessoriesPromise.always(function() {
					let entityText = additionalAccessoriesArray.reduce((entityText, item) => {
						entityText = `${entityText}
							<div class="accessoriesTable pt-3 pb-2" style="min-height: 130px;">
								<div class="accessoryImgContainer text-center mr-2 mr-sm-0">
									<span class="accessoryInfoTooltip position-relative d-inline-block"
										  style="width: 6rem; height: 5rem;"
										  data-toggle="tooltip"
										  title="<b>${item.name}</b>">
										<img class="m-auto" src="${item.image}" alt="${item.imageAlt}" style="max-width: 6rem; height: 6rem; object-fit: contain;">
									</span>
								</div>
								<div class="accessoryInfoContainer text-left">
									<strong>
										<a href="/viewitem.php?id=${item.id}"
										   class="accessory-type text-black text-link"
										   data-accessory-type="${item.type}">
											${item.type}
										</a>
									</strong>
									<p class="small mb-0 text-muted">${item.description}</p>
									<span class="accessoryInfoTooltip btn-link small d-sm-none" data-toggle="tooltip" title="<b>${item.name}</b>"></span>
								</div>
								<div class="accessoriesTablePriceAndCheckbox text-right">
									<div class="priceSection">
										<span class="d-block small text-muted lineThrough">$${item.listPrice}</span>
										<b class="d-block">$${item.discountPrice}</b>
									</div>
									<div>
										<div class="form-check d-flex align-items-center justify-content-end" style="gap: 0.5rem;">
											<label class="checkcontainer position-relative d-inline-block mb-0">
												<input type="checkbox"
													   class="form-check-input position-absolute add-checkbox add-checkbox-${item.id} add-on-extra"
													   data-accessory-id="${item.id}"
													   data-price="$${item.discountPrice}" style="width: 3rem;">
												<span class="checkmark"></span>
											</label>
											<span>Include</span>
										</div>
									</div>
								</div>
							</div>
						`;
						return entityText;
					}, '');

					$('#accessoriesData .accessory-table-body').append(entityText);
				});

				$(document.body).on('change', '.add-on-extra', function() {
					let thiselem = $(this),
						product = thiselem.data('accessoryId');

					if (thiselem.is(':checked')) {
						$.ajax({
							url: "/cart/addMultiple",
							type: "POST",
							dataType: "json",
							data: {
								format: "json",
								products: [product]
							},
							success: function(data) {
								accessoriesAdded[product] = data.products[product].cartItemID;
								if ('undefined' !== typeof ga) {
									ga('send', 'event', 'Cart', 'Additonal Stereo Accessories', 'Added item');
								}
							}
						});
					} else {
						$.ajax({
							url: "/cart/update",
							type: "POST",
							dataType: "json",
							data: {
								format: "json",
								remove_selected: true,
								"delete": [accessoriesAdded[product]]
							},
							success: function() {
								if ('undefined' !== typeof ga) {
									ga('send', 'event', 'Cart', 'Additonal Stereo Accessories', 'Removed item');
								}
							}
						});
					}
				});
			}
		},
		/**
		 * Event handler which adds speaker harness and adapters to the cart in
		 * the multiple speaker location flow.
		 * @returns {undefined}
		 */
		addInstallAccessoryMultLoc: function() {
			let cartItem = null,
				element = $(this),
				cartId = element.data('cartId'),
				cartItemId = element.data('cartItemId'),
				accessoryId = element.data('accessoryId'),
				accessoryTypeConstant = element.data('accessoryTypeConstant'),
				accessoriesTableContainer = $('#accessoriesTableContainer'),
				spinnerLoader = $('.accessory.spinner-border');

			accessoriesTableContainer.addClass('processing');
			spinnerLoader.show();
			cartItem = {
				cartId: cartId,
				cartItemId: cartItemId,
				accessoryId: accessoryId,
				accessoryTypeConstant: accessoryTypeConstant,
				addAccessory: (element.is(':checked') ? 'yes' : 'no')
			};
			$.ajax({
				url: "/cart/updateLocationBasedAccessory",
				type: "POST",
				dataType: "json",
				data: {
					cartItem: cartItem
				},
				success: function(data) {
					if (data.success) {
						let accessoryTotalHtml = $('#speakerAccessoryBtnContainer p span'),
							accessoryCountHtml = $('#speakerAccessoryBtnContainer p label'),
							sum = parseFloat(accessoryTotalHtml.html()),
							count = parseInt(accessoryCountHtml.html()),
							checkedAccessory = element.is(':checked'),
							checkedAccessoryPrice = element.data('accessoryPrice').replace('$', '').replace('FREE', '0.00');

						$('#selectedAccessoryTotal').removeClass('d-none');
						if (checkedAccessory) {
							sum += parseFloat(checkedAccessoryPrice);
							count++;
						} else {
							sum -= parseFloat(checkedAccessoryPrice);
							count--;
						}
						accessoryTotalHtml.html(sum.toFixed(2));
						accessoryCountHtml.html(count);
						if (count === 0) {
							$('#selectedAccessoryTotal').addClass('d-none');
						}
						accessoriesTableContainer.removeClass('processing');
						spinnerLoader.hide();
					}
				}
			});
		},
		/**
		 * Event handler which adds warranties to the cart in the multiple speaker location flow.
		 * @returns {undefined}
		 */
		addWarrantyMultLoc: function() {
			let warrantyCode = $(this),
				cartItem = null,
				cartItemId = warrantyCode.data('cartItemId'),
				warrantyId = warrantyCode.data('warrantyId'),
				planDetailsUrl = warrantyCode.data('planDetailsUrl'),
				warArray = {};

			warArray[cartItemId] = warrantyId;

			cartItem = {
				cartItemId: cartItemId,
				warrantyId: warrantyId,
				warranty: warArray,
				addWarranty: (warrantyCode.is(':checked') ? 'yes' : 'no')
			};

			warrantyCode.parent().find('.warrantyCode').not(warrantyCode).prop('checked', false)
				.closest('.extended-offer-card').removeClass('checked');
			if (warrantyCode.is(':checked')) {
				warrantyCode.closest('.extended-offer-card').addClass('checked');
			} else {
				warrantyCode.closest('.extended-offer-card').removeClass('checked');
			}

			if (planDetailsUrl) {
				$('.extended-warranty-offers-inner-container .plan-details-link').attr('href', planDetailsUrl);
			}

			$.ajax({
				url: "/cart/addLocationBasedCartItem",
				type: "POST",
				dataType: "json",
				data: {warrantyData: cartItem},
				success: function(data) {
					if (data.hasOwnProperty('redirect')) {
						window.location.replace(data.redirect);
					}
					$('#addedAddOnsTotal').removeClass('d-none');
					let selectedLocation = new Array(),
						warrantyPrice = new Array(),
						selectedWarrantyLabel = $('#warrantyStatus'),
						sum = 0;

					$('#WarrantySectionTableBody .warrantyCode:checked').each(function() {
						selectedLocation.push(this.value);
						warrantyPrice.push($(this).data('warrantyPrice'));
					});
					$.each(warrantyPrice, function() {
						sum += (parseFloat(this) || 0);
					});
					if (selectedLocation.length > 0) {
						selectedWarrantyLabel.show();
						selectedWarrantyLabel.html('<span style="font-weight: normal;">' + selectedLocation.length + (selectedLocation.length > 1 ? ' warranties' : ' warranty') + ' selected for:</span> $' + (sum));
					} else if (selectedLocation.length === 0) {
						selectedWarrantyLabel.hide();
					}
				}
			});
		},
		/**
		 * Event handler for the multiple speaker locations flow which adds the speakers
		 * to the cart for the selected locations and forwards to the multiple location
		 * install accessory screen.
		 * @returns {undefined}
		 */
		continueToInstallAccessories: function() {
			let locationBasedCartItem = [],
				locationBaseHarnesses = [],
				$productToAdd = $('#product-needing-accessories').val(),
				cartItemId = $('#cart_item_id').val(),
				accessoriesTableContainer = $('#accessoriesTableContainer'),
				noAccessoriesAvailable = $('.noAccessoriesAvailable'),
				pendingLocationRequests = 0,
				shouldSkipToAddOns = (noAccessoriesAvailable.length !== 0),
				redirectToAddOnsUrl = "/cart/add-ons/item/" + cartItemId + "/skip-to-addons/yes";

			let finalizeLocationProcessing = function() {
				if (pendingLocationRequests !== 0) {
					return;
				}
				let speakerExtendedWarrantyTable = $('#speakerExtendedWarrantyTable');
				speakerExtendedWarrantyTable.show();
				$('.accessory.spinner-border').hide();
				accessoriesTableContainer.removeClass('processing');
				if (speakerExtendedWarrantyTable.find('.warrantyCode').length < 1) {
					$('#extended-warranty-offers-popup-container').addClass('d-none');
				}
				if (shouldSkipToAddOns) {
					window.location.href = redirectToAddOnsUrl;
				}
			};

			let handleLocationRequestCompleted = function() {
				if (pendingLocationRequests > 0) {
					pendingLocationRequests--;
				}
				finalizeLocationProcessing();
			};

			$('#speakerLocationList .itemLocation:checked').each(function() {
				let $this = $(this),
					tempObj = {
						location: $this.val(),
						productId: $productToAdd,
						checkboxId: $this.attr('id')
					};

				if ($this.data('cartItemId')) {
					tempObj.cartItemId = cartItemId;
				}
				locationBasedCartItem.push(tempObj);
			});

			$('#accessoriesHeader, #locationConfirmation').hide();
			$('.accessory.spinner-border').show();
			if(noAccessoriesAvailable.length === 0)
			{
				accessoriesTableContainer.addClass('processing').show();
				$('#speakerAccessoryBtnContainer').show();
			}
			else
			{
				$('.iheader').removeClass('d-flex').hide();
			}
			for (let i = 0; i < locationBasedCartItem.length; i++) {
				pendingLocationRequests++;
				if (i === 0) {
					locationBasedCartItem[i].cartItemId = cartItemId;
				}
				$.ajax({
					url: "/cart/addLocationBasedCartItem",
					type: "POST",
					dataType: "json",
					data: {productData: locationBasedCartItem[i]},
					success: function(data) {
						if (data.hasOwnProperty('redirect')) {
							window.location.replace(data.redirect);
						}
						if (data.cartItem) {
							locationBasedCartItem[i].cartItemId = data.cartItem.cartItemId;
							locationBasedCartItem[i].accessoriesDetails = data.accessories;
							locationBasedCartItem[i].extendedWarranty = data.extendedWarranty;
							locationBaseHarnesses = data.harnesses;
							if (!$(`#${locationBasedCartItem[i].checkboxId}`).data('hasAccessory')) {
								if (locationBasedCartItem[i].accessoriesDetails.length > 0 || locationBaseHarnesses) {
									$('#accessoriesTableBody').append(
										'<tr class="accessoryRow-' + i + '" valign="top">' +
											'<td class="adapterColumn position-relative pt-3 pb-2">' +
												(('undefined' !== typeof locationBasedCartItem[i].accessoriesDetails
													&& (locationBasedCartItem[i].accessoriesDetails.length > 0)) ?
												`
												<span class="position-absolute custom-font-weight-600 bg-white pt-2" style="top: 0px; z-index: 1;">${locationBasedCartItem[i].location}</span>
												<div class="adapterColumncontainer d-flex align-items-center">
													<div class="custom-flex-1 text-center">
														<span class="accessoryInfoTooltip" data-toggle="tooltip" title="<b>${htmlspecialchars(locationBasedCartItem[i].accessoriesDetails[0].itemName)}</b><br><span>${htmlspecialchars(locationBasedCartItem[i].accessoriesDetails[0].savingsMessage)}</span>">
															<img src="${locationBasedCartItem[i].accessoriesDetails[0].thumbnailSource}" alt="${locationBasedCartItem[i].accessoriesDetails[0].thumbnailAlt}" style="max-width: 6rem;"/>
														</span>
													</div>
													<label class="mb-0 custom-flex-2">
														<strong>
															<a class="d-block text-black text-link" href="${locationBasedCartItem[i].accessoriesDetails[0].itemUrl}">${locationBasedCartItem[i].accessoriesDetails[0].itemType}</a>
															<span class="small m-0 text-muted">${htmlspecialchars(locationBasedCartItem[i].accessoriesDetails[0].itemDescription.heading)}</span>
														</strong>
													</label>
													<div class="custom-flex-1 text-right">
														<div class="priceSection">
															<span class="d-block small text-muted lineThrough">${locationBasedCartItem[i].accessoriesDetails[0].listPrice}</span>
															${((parseFloat(locationBasedCartItem[i].accessoriesDetails[0].discountPrice.replace('$', '').replace('FREE', '0.00')) < parseFloat(locationBasedCartItem[i].accessoriesDetails[0].sellingPrice.replace('$', ''))) || (parseFloat(locationBasedCartItem[i].accessoriesDetails[0].discountPrice.replace('$', '').replace('FREE', '0.00')) < parseFloat(locationBasedCartItem[i].accessoriesDetails[0].listPrice.replace('$', '')))) ?
															`<span class="badge badge-danger p-1 p-sm-2 small custom-font-weight-600">Save $${locationBasedCartItem[i].accessoriesDetails[0].saveAmount}</span>` : `<span></span>`}
															<b class="d-block">${locationBasedCartItem[i].accessoriesDetails[0].discountPrice}</b>
														</div>
														<div class="d-flex align-items-center justify-content-end" style="gap: 0.5rem;">
															<label type="checkbox" class="checkcontainer cursor-pointer position-relative mb-0">
																<input type="checkbox"
																	   checked
																	   class="accessoryCode"
																	   id="adapter-${i}"
																	   data-accessory-id="${locationBasedCartItem[i].accessoriesDetails[0].itemId}"
																	   data-accessory-price="${locationBasedCartItem[i].accessoriesDetails[0].discountPrice}"
																	   data-accessory-type-constant="${locationBasedCartItem[i].accessoriesDetails[0].itemTypeConstant}"
																	   data-cart-item-id="${locationBasedCartItem[i].cartItemId}"
																	   style="width: 3.5rem;">
																<span class="checkmark"></span>
															</label>
															<span class="cursor-pointer">Include</span>
														</div>
													</div>
												</div>` : `
												<span class="position-absolute custom-font-weight-600 bg-white pt-2" style="font-size:large; top: 0px; z-index: 1;">${locationBasedCartItem[i].location}</span>
												<div class="columnContainer noNeeded d-flex align-items-center position-relative" style="top: 1.25rem;">
													<span></span>
												</div>`) +
											'</td>' +
											'<td class="harnessColumn d-flex align-items-center pt-3 pb-2">' +
												(('undefined' !== typeof locationBaseHarnesses
													&& 'undefined' !== typeof locationBaseHarnesses[locationBasedCartItem[i].location]) ?
												`
												<div class="custom-flex-1 text-center">
													<span class="accessoryInfoTooltip" data-toggle="tooltip" title="<b>${locationBaseHarnesses[locationBasedCartItem[i].location].itemName}</b><br><span>${locationBaseHarnesses[locationBasedCartItem[i].location].savingsMessage}</span>">
														<img src="${locationBaseHarnesses[locationBasedCartItem[i].location].thumbnailSource}" alt="${locationBaseHarnesses[locationBasedCartItem[i].location].thumbnailAlt}" style="max-width: 6rem;"/>
													</span>
												</div>
												<label class="mb-0 custom-flex-2">
													<strong>
														<a class="d-block text-black text-link" href="${locationBaseHarnesses[locationBasedCartItem[i].location].itemUrl}">${locationBaseHarnesses[locationBasedCartItem[i].location].itemType}</a>
														<span class="small m-0 text-muted">${htmlspecialchars(locationBaseHarnesses[locationBasedCartItem[i].location].itemDescription)}</span>
													</strong>
												</label>
												<div class="custom-flex-1 text-right">
													<div class="priceSection">
														<span class="d-block small text-muted lineThrough">${locationBaseHarnesses[locationBasedCartItem[i].location].listPrice}</span>
														${ ((parseFloat(locationBaseHarnesses[locationBasedCartItem[i].location].discountPrice.replace('$', '').replace('FREE', '0.00')) < parseFloat(locationBaseHarnesses[locationBasedCartItem[i].location].sellingPrice.replace('$', ''))) || (parseFloat(locationBaseHarnesses[locationBasedCartItem[i].location].discountPrice.replace('$', '').replace('FREE', '0.00')) < parseFloat(locationBaseHarnesses[locationBasedCartItem[i].location].listPrice.replace('$', '')))) ?
														`<span class="badge badge-danger p-1 p-sm-2 small custom-font-weight-600">Save $${locationBaseHarnesses[locationBasedCartItem[i].location].saveAmount}</span>` : `<span></span>`}
														<b class="d-block">${locationBaseHarnesses[locationBasedCartItem[i].location].discountPrice}</b>
													</div>
													<div class="d-flex align-items-center justify-content-end" style="gap: 0.5rem;">
														<label type="checkbox" class="checkcontainer cursor-pointer position-relative mb-0">
															<input type="checkbox"
																   checked
																   class="accessoryCode"
																   id="harness-${i}"
																   data-accessory-id="${locationBaseHarnesses[locationBasedCartItem[i].location].itemId}"
																   data-accessory-price="${locationBaseHarnesses[locationBasedCartItem[i].location].discountPrice}"
																   data-accessory-type-constant="${locationBaseHarnesses[locationBasedCartItem[i].location].itemTypeConstant}"
																   data-cart-item-id="${locationBasedCartItem[i].cartItemId}"
																   style="width: 3.5rem;">
															<span class="checkmark"></span>
														</label>
														<span class="cursor-pointer">Include</span>
													</div>
												</div>` : '<div class="columnContainer noNeeded d-flex align-items-center"><span></span></div>') +
											'</td>' +
										'</tr>'
									);

									$(`#${locationBasedCartItem[i].checkboxId}`).data('cartItemId', locationBasedCartItem[i].cartItemId)
										.data('hasAccessory', true);
								}
							}
							if (!$(`#${locationBasedCartItem[i].checkboxId}`).data('hasWarranty')) {
								if (locationBasedCartItem[i].extendedWarranty.length > 0) {
									let warrantyContent = '';

									for (let j = 0; j < locationBasedCartItem[i].extendedWarranty.length; j++) {
										warrantyContent += `
											<div class="extended-offer-card card mr-2 text-center cursor-pointer" style="flex: 1; border-radius: 5px;">
												<label class="checkcontainer m-0 mr-2 cursor-pointer d-none">
													<input type="checkbox"
														   id="extended-offer-${j}_${locationBasedCartItem[i].cartItemId}"
														   class="warrantyCode mr-2"
														   value="${locationBasedCartItem[i].location}"
														   data-cart-item-id="${locationBasedCartItem[i].cartItemId}"
														   data-plan-details-url="${locationBasedCartItem[i].extendedWarranty[j].planDetailsUrl}"
														   data-warranty-id="${locationBasedCartItem[i].extendedWarranty[j].id}"
														   data-warranty-price="${locationBasedCartItem[i].extendedWarranty[j].price}">
													<span class="checkmark"></span>
												</label>
												<label class="extended-offer-value m-0 p-2 cursor-pointer" for="extended-offer-${j}_${locationBasedCartItem[i].cartItemId}" style="font-size: 1rem;">
													<span class="d-block small">${locationBasedCartItem[i].extendedWarranty[j].description}</span>
													<span class="offerPrice" style="font-weight: 700;">$${locationBasedCartItem[i].extendedWarranty[j].price}</span>
												</label>
											</div>
										`;
									}
									if (warrantyContent) {
										$('#WarrantySectionTableBody').append(`
											<div class="locationColumn pb-1 text-left">
												<span><b>${locationBasedCartItem[i].location} speaker:</b></span>
											</div>
											<div class="extended-offers-body d-flex align-items-center">
												${warrantyContent}
											</div>
										`);
									}

									$(`#${locationBasedCartItem[i].checkboxId}`).data('cartItemId', locationBasedCartItem[i].cartItemId)
										.data('hasWarranty', true);
								}
							}
						}


						let element = $('#adapter-' + i),
							elementHarness = $('#harness-' + i);

						if (element.length > 0) {
							let cartItem = null,
								cartId = element.data('cartId'),
								cartItemId = element.data('cartItemId'),
								accessoryId = element.data('accessoryId'),
								accessoryTypeConstant = element.data('accessoryTypeConstant');

							cartItem = {
								cartId: cartId,
								cartItemId: cartItemId,
								accessoryId: accessoryId,
								accessoryTypeConstant: accessoryTypeConstant,
								addAccessory: (element.is(':checked') ? 'yes' : 'no')
							};
							$.ajax({
								url: "/cart/updateLocationBasedAccessory",
								type: "POST",
								dataType: "json",
								data: {
									cartItem: cartItem
								},
								success: function(data) {
									if (data.success) {
										let accessoryTotalHtml = $('#speakerAccessoryBtnContainer p span'),
											accessoryCountHtml = $('#speakerAccessoryBtnContainer p label'),
											sum = parseFloat(accessoryTotalHtml.html()),
											count = parseInt(accessoryCountHtml.html()),
											checkedAccessory = element.is(':checked'),
											checkedAccessoryPrice = element.data('accessoryPrice').replace('$', '').replace('FREE', '0.00');

										$('#selectedAccessoryTotal').removeClass('d-none');
										if (checkedAccessory) {
											sum += parseFloat(checkedAccessoryPrice);
											count++;
										} else {
											sum -= parseFloat(checkedAccessoryPrice);
											count--;
										}
										accessoryTotalHtml.html(sum.toFixed(2));
										accessoryCountHtml.html(count);
										if (count === 0) {
											$('#selectedAccessoryTotal').addClass('d-none');
										}
									}
								}
							});
						}

						if (elementHarness.length > 0) {
							let cartItemHarness = null,
								cartIdHarness = elementHarness.data('cartId'),
								cartItemIdHarness = elementHarness.data('cartItemId'),
								accessoryIdHarness = elementHarness.data('accessoryId'),
								accessoryTypeConstantHarness = elementHarness.data('accessoryTypeConstant');

							cartItemHarness = {
								cartId: cartIdHarness,
								cartItemId: cartItemIdHarness,
								accessoryId: accessoryIdHarness,
								accessoryTypeConstant: accessoryTypeConstantHarness,
								addAccessory: (elementHarness.is(':checked') ? 'yes' : 'no')
							};
							$.ajax({
								url: "/cart/updateLocationBasedAccessory",
								type: "POST",
								dataType: "json",
								data: {
									cartItem: cartItemHarness
								},
								success: function(data) {
									if (data.success) {
										let accessoryTotalHtml = $('#speakerAccessoryBtnContainer p span'),
											accessoryCountHtml = $('#speakerAccessoryBtnContainer p label'),
											sum = parseFloat(accessoryTotalHtml.html()),
											count = parseInt(accessoryCountHtml.html()),
											checkedAccessory = elementHarness.is(':checked'),
											checkedAccessoryPrice = elementHarness.data('accessoryPrice').replace('$', '').replace('FREE', '0.00');

										$('#selectedAccessoryTotal').removeClass('d-none');
										if (checkedAccessory) {
											sum += parseFloat(checkedAccessoryPrice);
											count++;
										} else {
											sum -= parseFloat(checkedAccessoryPrice);
											count--;
										}
										accessoryTotalHtml.html(sum.toFixed(2));
										accessoryCountHtml.html(count);
										if (count === 0) {
											$('#selectedAccessoryTotal').addClass('d-none');
										}
									}
								}
							});
						}
					},
					complete: function() {
						handleLocationRequestCompleted();
					}
				});
			}
		},
		/**
		 * Deselects the install accessories checkbox when the #declineAccessoriesBtn element is clicked
		 * and calls updateCartButton.
		 * @param {Event} e
		 * @returns {undefined}
		 */
		declineAccessoriesHandler: function(e) {
			e.preventDefault();
			$('#accessoriesData .add-checkbox').prop('checked', false).trigger('change');
			responsiveCart.installAccessoryPopupController.updateCartButton();
			$('#carSpecificAccessoryForm').submit();
		},
		/**
		 * Event handler display additional vehicle speaker locations screen in the fit flow.
		 * @param {Event} e
		 * @returns {undefined}
		 */
		showVehicleSpeakerLocationFromFit: function(e) {
			e.preventDefault();
			$('#fitSpeakerList').removeClass('d-none');
			$(this).addClass('d-none');
		},
		/**
		 * Event handler display additional vehicle speaker locations screen in the no fit flow.
		 * @param {Event} e
		 * @returns {undefined}
		 */
		showVehicleSpeakerLocationFromNoFit: function(e) {
			e.preventDefault();
			$('#accessoriesData, #accessoriesAddOnsBtn').addClass('d-none');
			$('#fitSpeakerList').removeClass('d-none');
			$('#productNoFit').find('.iheader').addClass('d-none')
				.end().find('.backLink').removeClass('d-none');
		},
		/**
		 * Event handler for the multiple speaker location flow handles the user speaker location selections.
		 * @returns {undefined}
		 */
		speakerLocationListChange: function() {
			let selectedLocation = new Array(),
				cartItemPrice = parseFloat($('#accessory-cart-item-price').val()),
				locationConfirmation = $('#locationConfirmation'),
				selectedLocationLabel = $('#selectedLocationLabel'),
				locationCheckBoxesChecked = $('#speakerLocationList .itemLocation:checked');

			if (locationCheckBoxesChecked.length < 1) {
				locationConfirmation.addClass('disable');
			} else {
				locationConfirmation.removeClass('disable');
			}

			locationCheckBoxesChecked.each(function () {
				selectedLocation.push(this.value);
			});

			if (selectedLocation.length > 0) {
				selectedLocationLabel.show();
				locationConfirmation.find('.errorMessage').addClass('d-none');
				selectedLocationLabel.html('<span style="font-weight: normal;">Selected location' + (selectedLocation.length > 1 ? 's' : '') + ':</span> ' + selectedLocation.join(', ') + '. <span class="text-nowrap"><span style="font-weight: normal;">Total:</span> $' + (selectedLocation.length * cartItemPrice).toFixed(2) + '</span>');
			} else if (selectedLocation.length === 0) {
				selectedLocationLabel.hide();
				locationConfirmation.find('.errorMessage').removeClass('d-none').text('One location must be selected for the added item');
			}
		},
		/**
		 * Event handler for the fit speaker location links.
		 * @returns {undefined}
		 */
		submitAccessoryFormAndGoToSpeakerFitLocation: function() {
			let checkedAccessory = $('#accessoriesData .add-checkbox').filter(':checked');

			if (checkedAccessory.length > 0) {
				$('#redirect_after_action').val($(this).data('url'));
				$('#carSpecificAccessoryForm').submit();
			} else {
				let newUrl = $(this).data('url');

				window.location.replace(newUrl);
			}
		},
		/**
		 * Updates the text in the #addAccessoriesBtn element that appears when install
		 * accessories are available for a head unit or a speaker in the single location flow.
		 * @returns {undefined}
		 */
		updateCartButton: function() {
			let sum = 0,
				checkedAccessory = $('#accessoriesData .add-checkbox').filter(':checked'),
				partPlural = (checkedAccessory.length > 1 ? ' parts' : ' part'),
				sumDisplay,
				addToCartText;

			$.each(checkedAccessory, function() {
				sum += parseFloat($(this).data('price').replace('$', ''));
			});
			sumDisplay = (sum.toFixed(2) !== '0.00' ? '$' + sum.toFixed(2) : 'FREE');
			if (checkedAccessory.length > 0) {
				addToCartText = 'Add ' + checkedAccessory.length + partPlural + ' for ' + sumDisplay;
			} else {
				addToCartText = 'Continue with no parts selected';
			}
			$('#addAccessoriesBtn').val(addToCartText);
		}
	},
	/**
	 * Adds a finance option as a GET parameter to set payment method
	 * as a default payment method for order.
	 * @returns {undefined}
	 */
	proceedToCheckout: function() {
		let url = $('.bottomCartCheckout').attr('href'),
			selectedMethod = $('input[name="payment-method"]:checked').val();

		// Add finance=true to url only if Affirm payment-method is selected
		if ('affirm' === selectedMethod) {
			$('.bottomCartCheckout').attr('href', url + '?finance=true');
		}
	},
	/**
	 * Adds a remove item input element and submits the cart form.
	 * @returns {undefined}
	 */
	removeItem: function() {
		let action = $('<input type="hidden" name="remove_selected" value="yes">'),
			item = $('<input type="hidden" name="delete[]" value="' + $(this).data('item') + '">');

		responsiveCart.cartForm.append(action, item).submit();
	},
	/**
	 * Checks for dual coupon fields and puts up a modal while the cart form is being submitted.
	 * @returns {undefined}
	 */
	showInterstitialModal: function() {
		let couponFields = $('.coupon-input');

		if (couponFields[0] && couponFields[1]) {
			let field1Val = couponFields[0].value,
				field2Val = couponFields[1].value;

			if (field1Val != field2Val) {
				if ('' != field1Val) {
					couponFields[1].value = field1Val;
				} else {
					couponFields[0].value = field2Val;
				}
			}
		}

		if (typeof responsiveCart.zipModal.modal === 'function'
			&& typeof responsiveCart.zipModal.modal !== 'undefined'
		) {
			responsiveCart.zipModal.modal('hide');
		}

		if (typeof responsiveCart.interstitialModal.modal === 'function'
			&& typeof responsiveCart.interstitialModal.modal !== 'undefined'
		) {
			responsiveCart.interstitialModal.modal('show');
		}

		setTimeout(function() {
			responsiveCart.interstitialModal.modal('hide');
			throw new Error('Saving cart modal did not complete in 30 seconds.');
		}, 30000);
	},
	/**
	 * Removes a current cart item from the  cart and added selected bundle product to the cart.
	 * @returns {undefined}
	 */
	upgradeToBundle: function () {
		let $elem = $(this),
			addItemBadge = $elem.closest('.productContainer').find('.addItemBadge');

		addItemBadge.show();

		$.ajax({
			url: "/cart/update",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				remove_selected: true,
				delete: [$elem.data('cartItemId')]
			},
			success: function(data) {
				if (data && data.deleteCount) {
					let redirectUrl = '/cart/add?item=' + $elem.data('productId');
					window.location.replace(redirectUrl);
					// Facebook pixel
					let index = responsiveAccessoryPopupSingle.facebook_content_ids.indexOf($elem.data('productId'));
					if (index > -1) {
						responsiveAccessoryPopupSingle.facebook_content_ids.splice(index, 1);
					}
				}
			},
			error: function() {
				addItemBadge.html('Something went wrong').css('background', 'red');
			},
		});
	}
};
window.responsiveCart = responsiveCart;

// DOM ready
$(function() {
	responsiveCart.init();
});